import { Component, OnInit } from '@angular/core';

import { IndicatorsAllEconomicDataViewResponse } from 'IndicatorsApp/ts/interfaces/data-view-responses.interface';

import { IndicatorsService } from 'IndicatorsApp/ts/services/indicators.service';

@Component({
    standalone: false,
    selector: 'ycn-all-economic-data-module',
    templateUrl: './all-economic-data.template.html',
})
export class AllEconomicDataComponent implements OnInit {
    data!: IndicatorsAllEconomicDataViewResponse;

    dropdownTogglesShow: { [key: string]: boolean } = {};

    sections: string[] = [];

    constructor(private indicatorService: IndicatorsService) {}

    ngOnInit(): void {
        this.indicatorService
            .getIndicatorsAllEconomicData()
            .subscribe((response: IndicatorsAllEconomicDataViewResponse) => {
                this.data = response;
                this.sections = Object.keys(this.data);
                this.dropdownTogglesShow = Object.assign({}, ...this.sections.map((section) => ({ [section]: false })));
            });
    }

    updateToggle(section: string): void {
        this.dropdownTogglesShow[section] = !this.dropdownTogglesShow[section];
    }

    // Preserves dictionary insertion order
    originalOrder(): number {
        return 0;
    }
}
